import {
  MessageAttributeValue,
  SQSClient,
  SendMessageCommand,
} from "@aws-sdk/client-sqs"
import { refItem } from "@tc/drizzle-v2"
import { DbTransaction } from "@tc/middy-decorators"
import { eq } from "drizzle-orm"
import { ItemDoc } from "../types/reference-data"
import { searchBuilderLog } from "../utils/logger"

const sqs_client = new SQSClient({})
const queue_url = process.env["ITEM_QUEUE_URL"]

export const getRefItemData = async (
  tx: DbTransaction,
  id: string,
): Promise<ItemDoc | undefined> => {
  const [row] = await tx
    .select({
      id: refItem.id,
      listCode: refItem.listCode,
      itemCode: refItem.itemCode,
      itemName: refItem.itemName,
      unCode: refItem.unCode,
      parentCode: refItem.parentCode,
      active: refItem.active,
      effectiveStartDate: refItem.effectiveStartDate,
      effectiveEndDate: refItem.effectiveEndDate,
      updatedAt: refItem.updatedAt,
      updatedBy: refItem.updatedBy,
    })
    .from(refItem)
    .where(eq(refItem.id, parseInt(id)))

  if (!row) {
    console.error(`RefItem with id ${id} not found`)
    return
  }

  const refItemDoc: ItemDoc = {
    id: row.id.toString(),
    list_code: row.listCode,
    item_code: row.itemCode,
    item_name: row.itemName,
    un_code: row.unCode,
    parent_code: row.parentCode ?? "NOT_APPLICABLE",
    active: row.active,
    effective_start_date: new Date(row.effectiveStartDate).getTime(),
    effective_end_date: row.effectiveEndDate
      ? new Date(row.effectiveEndDate).getTime()
      : 0,
    updated_at: row.updatedAt.getTime(),
    updated_by: row.updatedBy,
  }

  searchBuilderLog.debug({
    document: refItemDoc,
  })

  return refItemDoc
}

export const saveRefItemToSearch = async (
  tx: DbTransaction,
  id: string,
  collectionName: string,
  options?: { returnDoc?: boolean },
): Promise<void> => {
  const doc = await getRefItemData(tx, id)

  if (!doc || Object.keys(doc).length === 0) {
    console.error(`Failed to prepare document for id: ${id}`)
    return
  }

  if (options?.returnDoc) return doc as never

  const attributes: Record<string, MessageAttributeValue> = {
    collection: {
      StringValue: collectionName,
      DataType: "String",
    },
  }

  const command = new SendMessageCommand({
    QueueUrl: queue_url,
    MessageBody: JSON.stringify(doc),
    MessageAttributes: attributes,
  })

  await sqs_client.send(command)
}
